// ---------- header search bar  ---------------
// document.addEventListener("DOMContentLoaded", function () {
//   function moveSearch() {
//     const headerSearch = document.querySelector('.header__search');
//     const headerIcons = document.querySelector('.header__icons');
//     if (headerSearch && headerIcons && !headerIcons.contains(headerSearch)) {
//       headerIcons.insertBefore(headerSearch, headerIcons.firstChild);
//       console.log("✅ Header search moved inside header__icons (first position)");
//       return true;
//     }
//     return false;
//   }

//   // Try immediately (prevents flicker)
//   if (!moveSearch()) {
//     // Retry every 100ms if not ready yet
//     const interval = setInterval(() => {
//       if (moveSearch()) clearInterval(interval);
//     }, 100);

//     // Stop after 3 seconds
//     setTimeout(() => clearInterval(interval), 3000);
//   }
// });


document.addEventListener("DOMContentLoaded", function () {

  const customTrigger = document.getElementById("customSearchTrigger");
  const realButton = document.getElementById("realSearchButton");
  const modalDetails = document.querySelector("#realSearchModal details");
  const closeBtn = document.querySelector(".search-modal__close-button");
  const overlay = document.querySelector(".modal-overlay");

 

// const realButton = document.querySelector(".real-search-btn");

if (customTrigger && realButton) {
  customTrigger.addEventListener("click", () => {
    realButton.click();
  });
}


  // ⭐ CLOSE MODAL
  function closeModal() {
    modalDetails.removeAttribute("open");
  }

  if (closeBtn) closeBtn.addEventListener("click", closeModal);
  if (overlay) overlay.addEventListener("click", closeModal);

});




document.addEventListener("DOMContentLoaded", function () {

  const handleMap = {
    "yellow sapphire": "all-gemstones-yellow-sapphire-pukhraj",
    "yellow sapphire (pukhraj)": "all-gemstones-yellow-sapphire-pukhraj",
  };

  const megaMenu = document.querySelector("#MegaMenu-Content-10 ul.mega-menu__list");
  if (!megaMenu) return;

  const items = Array.from(megaMenu.querySelectorAll("li"));
  if (!items.length) return;

  const container = document.createElement("div");
  container.classList.add("container", "py-0");

  const row = document.createElement("div");
  row.classList.add("row", "g-4");

  const itemsPerCol = 5;
  const totalCols = Math.ceil(items.length / itemsPerCol);

  for (let i = 0; i < totalCols; i++) {

    const col = document.createElement("div");
    col.classList.add("col-md-3", "col-sm-6");

    const ul = document.createElement("ul");
    ul.classList.add("list-unstyled", "mega-menu__list", "mega-menu__list--condensed");

    const start = i * itemsPerCol;
    const end = start + itemsPerCol;
    const chunk = items.slice(start, end);

    chunk.forEach(li => {
      const link = li.querySelector("a");
      const name = link.textContent.trim().toLowerCase();

      const cleanedName = name.replace(/ *\([^)]*\) */g, "").trim();

      const handle =
        handleMap[name] ||
        handleMap[cleanedName] ||
        cleanedName.replace(/ /g, "-");

      const jsonURL = `/collections/${handle}.json`;

      fetch(jsonURL)
        .then(res => res.json())
        .then(data => {

          let imgSrc = "";

          if (data?.collection?.image?.src) {
            imgSrc = data.collection.image.src;
          } else if (data?.products?.length > 0) {
            imgSrc = data.products[0]?.images?.[0]?.src || "";
          }

          li.innerHTML = `
            <div class="d-flex align-items-center gap-2 mb-2">
              ${imgSrc ? `<img src="${imgSrc}" class="menu-img" style="width:30px;height:20px;object-fit:contain;border-radius:3px;">` : ""}
              <a href="/collections/${handle}" class="mega-menu__link">
                ${link.textContent.trim()}
              </a>
            </div>
          `;
        })
        .catch(err => console.warn("No image for:", handle));

      ul.appendChild(li);
    });

    col.appendChild(ul);
    row.appendChild(col);
  }

  container.appendChild(row);
  megaMenu.parentNode.replaceChild(container, megaMenu);
});



// ----------- collection  list   img --------

document.addEventListener("DOMContentLoaded", function () {

  const iconURL =
    "https://cdn.shopify.com/s/files/1/0820/2869/1736/files/checkiconfordesk.png?v=1763640965";

  // Target ONLY collection banner list items
  const listItems = document.querySelectorAll(".collection-hero li");

  listItems.forEach(li => {
    
    // Avoid duplicate icons if JS reloads
    if (li.querySelector("img.check-icon")) return;

    const icon = document.createElement("img");
    icon.src = iconURL;
    icon.className = "check-icon";
    icon.alt = "check";

    // Add icon before text
    li.prepend(icon);
  });
});



document.addEventListener("DOMContentLoaded", function () {

  const certURL = window.collectionCertificate;
  if (!certURL || certURL === "") return;   // metafield empty → do nothing

  // Your certificate thumbnail image
  const certificateThumb = "https://cdn.shopify.com/s/files/1/0820/2869/1736/files/certificate-thumbnail.png?v=1764335319";

  // Grab Shopify thumbnail slider UL
  const slider = document.querySelector("[id^='Slider-Thumbnails']");
  if (!slider) return;

  // Create new LI
  let li = document.createElement("li");
  li.className = "thumbnail-list__item slider__slide";
  li.style.cursor = "pointer";

  li.innerHTML = `
    <button class="thumbnail global-media-settings global-media-settings--no-shadow">
      <img 
        src="${certificateThumb}" 
        alt="Certificate"
        style="width:100%; border-radius:6px;"
      >
    </button>
  `;

  // On click → open metafield certificate
  li.addEventListener("click", function () {
    window.open(certURL, "_blank");
  });

  // Add to end of slider
  slider.appendChild(li);

});


// --------


document.addEventListener("DOMContentLoaded", function() {
  const links = document.querySelectorAll(".top-inline-menu a");
  
  let hasActive = false;
  
  // Check if Shopify already set any active
  links.forEach(link => {
    if (link.classList.contains("active")) {
      hasActive = true;
    }
  });

  // If no menu is active -> set Gemstones active
  if (!hasActive) {
    links.forEach(link => {
      if (link.textContent.trim().toLowerCase() === "gemstones") {
        link.classList.add("active");
      }
    });
  }
});

document.addEventListener("DOMContentLoaded", function() {
  const links = document.querySelectorAll(".top-inline-menu a");

  links.forEach(link => {
    if (link.textContent.trim().toLowerCase() === "rudraksha") {
      link.setAttribute("target", "_blank");
    }
  });
});


// ------- disclaimer code  ----

document.addEventListener("DOMContentLoaded", function () {

  const selectedText = document.getElementById("bgm-selected-text");
  const ringDisclaimer = document.getElementById("bgm-ring-disclaimer");

  // ONLY top buying options
  document.querySelectorAll(".bgm-buying-options .bgm-option").forEach(option => {
    option.addEventListener("click", function () {

      const selectedOption = this.getAttribute("data-option");

      if (selectedOption === "ring") {
        selectedText.textContent = "Ring";
        ringDisclaimer.style.display = "block";
      }

      if (selectedOption === "pendant") {
        selectedText.textContent = "Pendant";
        ringDisclaimer.style.display = "block";
      }

      if (selectedOption === "loose") {
        ringDisclaimer.style.display = "none";
      }

    });
  });

  // P click → hide disclaimer
const hideBtn = document.getElementById("bgm-hide-disclaimer");

if (hideBtn) {
  hideBtn.addEventListener("click", function () {
    ringDisclaimer.style.display = "none";
  });
}

});

// ----------- products sticky -------------------

async function addToCartFromWishlist(variantId, button) {
    button.innerText = 'Adding...';
    button.disabled = true;

    try {
        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                items: [{
                    id: variantId,
                    quantity: 1
                }]
            })
        });

        if (response.ok) {
            button.innerText = 'Added to Cart! ✅';
            button.style.background = '#4CAF50';
            
            // Optional: Header cart bubble update karne ke liye page refresh ya dispatch
            setTimeout(() => {
                window.location.href = '/cart'; // Seedha cart page par le jao
            }, 500);
        } else {
            throw new Error('Cart update failed');
        }
    } catch (error) {
        console.error('Error:', error);
        button.innerText = 'Error! Try again';
        button.disabled = false;
    }
}



// collection title


